module.exports = __webpack_public_path__ + "static/media/basketball-hoop.89f97f95.svg";